import { EVENT_META, EVENT_TYPES, type EventType } from '@bb/shared/core';
import { Icon, Sheet, TYPE_ICON } from '../components';
import { categoryOf } from '../lib';
import { useApp } from '../state';

const ORDER: EventType[] = ['breast', 'bottle', 'solid', 'sleep', 'diaper', 'walk', 'bath', 'gym', 'cry', 'activity', 'medicine', 'temperature', 'measure', 'note'];

export function AddSheet({ onClose }: { onClose: () => void }) {
  const ctx = useApp();
  const types = ORDER.filter((t) => EVENT_TYPES.includes(t));
  return (
    <Sheet title="Добавить запись" onClose={onClose}>
      <div className="tiles3">
        {types.map((t) => {
          const cat = categoryOf(t);
          return (
            <button key={t} type="button" className={`tile ${cat === 'other' ? 'plain' : `cat-${cat}`}`} onClick={() => ctx.openAction(t)}>
              <Icon name={TYPE_ICON[t]} size={26} />
              {EVENT_META[t].label}
            </button>
          );
        })}
        {(ctx.family.settings?.customKinds ?? []).map((k) => (
          <button
            key={k.id}
            type="button"
            className={`tile ${k.cat === 'other' ? 'plain' : `cat-${k.cat}`}`}
            onClick={() => ctx.openEditor({ type: 'custom', preset: { kindId: k.id, name: k.name, cat: k.cat, ...(k.unit ? { unit: k.unit } : {}) } })}
          >
            <span style={{ fontSize: 22 }} aria-hidden="true">
              {k.emoji}
            </span>
            {k.name}
          </button>
        ))}
      </div>
      <p className="tiny muted">Время можно поставить любое — в том числе задним числом.</p>
    </Sheet>
  );
}
